import src from '/Users/huynhducduy/workspace/innosearch/innosearch-fe/interface/src/assets/stores/StoresHeroLandingImage.png?url';

export default {
  lqip: `data:image/png;base64,UklGRqwAAABXRUJQVlA4IKAAAACQBACdASogAAwAPm0skkWkIqGYBABABsSzAE6ZQZBAGbfnY4XdsZmGFn/b6VAA/vVJSB70CCPaXBqeOlvcvuwhQ3gUEgQ4+jKNvvj6/bkf3Gyk4aLz1/47uRiJLXXb/kWq7obb/92+xbX36dB3WTEio06DxAScbXt7ompC/WSMUSc5NgATI78YO7zvuiKNVW3QQxMM2Oik/fMrOorVRAAA`,
  src,
  width: 4317,
  height: 1554,
};
			